import type { InfiniteData } from "@tanstack/react-query"
import type {
	TicketDTO,
	TicketListResponse,
	TicketStatus,
} from "@zplanem/responses"

type TicketStatusCache = {
	status: TicketStatus
	data: InfiniteData<TicketListResponse> | undefined
}

export function optimisticTicketStatusMove(
	caches: readonly TicketStatusCache[],
	ticketId: string,
	targetStatus: TicketStatus,
): Map<TicketStatus, InfiniteData<TicketListResponse>> | null {
	let ticketToMove: TicketDTO | null = null

	for (const cache of caches) {
		for (const page of cache.data?.pages ?? []) {
			const ticket = page.tickets.find((item) => item.id === ticketId)
			if (ticket) {
				ticketToMove = ticket
				break
			}
		}
		if (ticketToMove) break
	}

	if (!ticketToMove || ticketToMove.status === targetStatus) return null

	const movedTicket = { ...ticketToMove, status: targetStatus }
	const next = new Map<TicketStatus, InfiniteData<TicketListResponse>>()

	for (const cache of caches) {
		if (!cache.data) continue
		const pages = cache.data.pages.map((page) => ({
			...page,
			tickets: page.tickets.filter((ticket) => ticket.id !== ticketId),
		}))

		if (cache.status === targetStatus && pages[0]) {
			pages[0] = {
				...pages[0],
				tickets: [movedTicket, ...pages[0].tickets],
			}
		}

		next.set(cache.status, {
			...cache.data,
			pages,
		})
	}

	return next
}
